var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1563",
  "data-name": "Group 1563",
  transform: "translate(11.707 -4.5) rotate(90)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_32",
  "data-name": "Line 32",
  x2: 18,
  transform: "translate(5 6)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_33",
  "data-name": "Line 33",
  x2: 5,
  y2: 5,
  transform: "translate(19 1)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_34",
  "data-name": "Line 34",
  y1: 5,
  x2: 5,
  transform: "translate(19 6)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1
}));
function SvgWhiteArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.414,
    height: 20.207,
    viewBox: "0 0 11.414 20.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowDown);
export default __webpack_public_path__ + "static/media/white-arrow-down.ecf60a234ec78c0b992bf174f13cc648.svg";
export { ForwardRef as ReactComponent };